import { I18n } from '@calendly/i18n'

import { useProductRefreshAppShell } from 'features/app_shell/product_refresh/useProductRefreshAppShell'

import { Summary } from './summary'
import { AccordionPanel } from '../../../components/accordion'
import { Notifications } from '../../components/notifications'
import { useWorkflows } from '../use_workflows'

export const NotificationsPanel = ({ isLocked, ...props }) => {
  const workflows = useWorkflows({ withAdminManaged: true })
  const isWorkflowsAppShellRebrand = useProductRefreshAppShell()

  return (
    <AccordionPanel
      titleId="notifications-label"
      title={I18n.t(isWorkflowsAppShellRebrand
        ? 'publisher.workflows_app_shell_rebrand.event_type_editor.notifications.title'
        : 'publisher.event_type_editor.sections.more_options.notifications.title'
      )}
      subheader={<Summary workflows={workflows.list || []} />}
      {...props}
    >
      <Notifications workflows={workflows} />
    </AccordionPanel>
  )
}
